<h1 mat-dialog-title></h1>
<div mat-dialog-content>
    {{data.text}}
</div>
<div mat-dialog-actions align="end">
    <button color="warn" mat-raised-button [mat-dialog-close]="false">Nein</button>
    <button color="primary" mat-raised-button [mat-dialog-close]="true" cdkFocusInitial>Ja</button>
</div>